<template>
  <v-container fluid class="pa-0">
    <!-- <view-header title="Freight Forwarders" description="View the Freight Forwarders details." icon="mdi-account-outline"/> -->
    <v-container fluid class="pa-5">
      <data-table 
        :items="freightforwarders" 
        :loading="loading"  
        :hideAddButton="true"
        :showCardView="false"
        :headers="headers" 
        :search="search"
        :show_excel="true"
        :show_print="true"
        title="Freight Forwarders"
        @reload="getUsers"
      >
        <template v-slot:item.status="{ item }">
          <v-chip dark color="green lighten-2" v-if="item.id == user.id">
            <v-icon dark class="mr-2">mdi-account-check</v-icon>
            Currently Logged In {{getRoleDescription(item.roleId)}}
          </v-chip>
          <v-chip v-else>
            <v-icon class="mr-2">mdi-account</v-icon>
            {{getRoleDescription(item.roleId)}}
          </v-chip>
        </template>
      </data-table>
    </v-container>
    <user-edit v-model="showEditUser" :user="currentUser"></user-edit>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DataTable from '@/components/DataTable'
import UserEdit from '@/components/UserEdit';

export default {
  data() {
    return  {
      headers: [{
        text: 'Email',
        value: 'email'
      },{
        text: 'Name',
        value: 'userFullName'
      },{
        text: 'Phone',
        value: 'phone'
      },{
        text: 'Address',
        value: 'address'
      },{
        text: 'Drivers',
        value: 'strDrivers'
      },{
        text: 'Trucks',
        value: 'strTrucks'
      }
      ],
      search: '',
      currentUser: {},
      showEditUser: false
    }
  },
  computed: {
    ...mapState('users',['user','freightforwarders','loading'])
  },
  components: {
    DataTable, UserEdit
  },
  methods: {
    ...mapActions('users',['getUsers']),
    /*editUser(currentUser) { 
      if (currentUser == undefined) {
        this.currentUser = {
          id: 0,
          username: '',
          password: '',
          confirmPassword: '',
          Name:'',
          Company:''
        }
      } else {
        this.currentUser = currentUser;
      }
      this.showEditUser = true;
    },
    */
    getRoleDescription(role_id) {
      if(role_id===1){
        return "Admin";
      }else if(role_id===5){
        return "Freight Forwarder";
      }else {
        return "Client";
      } 
    }
  },
  mounted() {
    console.log("Users mo0unted");
    this.getUsers();
    
  }
}
</script>